import { render } from "./SupplierHeadCreate.vue?vue&type=template&id=82511826"
import script from "./SupplierHeadCreate.vue?vue&type=script&lang=js"
export * from "./SupplierHeadCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__